import { http } from '@/api/Connect';

import { TDailyCheckIn } from '@/api/schema';

const API_DAILY_CHECK_IN = {
  GET(operatorId: string | number): string {
    return `/api/v1/daily-checkin/${operatorId}`;
  },
  UPDATE(operatorId: string | number): string {
    return `/api/v1/daily-checkin/${operatorId}`;
  }
};

export async function getDailyCheckIn(
  operatorId: number | string
): Promise<TDailyCheckIn> {
  const { data } = await http.get<TDailyCheckIn>(
    API_DAILY_CHECK_IN.GET(operatorId),
    {
      cacheTime: 0,
      paramsSerializer: {
        indexes: null
      }
    }
  );

  return data;
}

export async function updateDailyCheckIn(
  operatorId: number | string,
  data: Record<string, unknown>
): Promise<TDailyCheckIn> {
  const { data: response } = await http.post<TDailyCheckIn>(
    API_DAILY_CHECK_IN.UPDATE(operatorId),
    data
  );

  return response;
}
